export default "__VITE_ASSET__CXnVl4hz__"